<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>IDENTIFYING CAP BADGES</h1>
<p class="subtitle">A FAMILY HISTORIAN’S GUIDE</p>
<p class="author">GRAHAM BANDY</p>
<div class="image_container">
<img alt="images" src="images/logo.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?3d366ce0